module.exports = __webpack_public_path__ + "538555d2b0888ce191f62fdbeae649a8.pdf";